import { render, staticRenderFns } from "./LanguageSelectIcon.vue?vue&type=template&id=42b13be9"
import script from "./LanguageSelectIcon.vue?vue&type=script&lang=ts"
export * from "./LanguageSelectIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports